import lazyPage from 'packages/core/hoc/lazyPage'

export default () => [
  {
    component: lazyPage(() => import('app/view/Errors/PageNotFound')),
  },
]
